import React from 'react';
import { Form } from 'semantic-ui-react';
import { getPrimaryLocationId } from './LocationsSelect.utils';
import { LocationPropType } from '../../../services/proptypes';
import './LocationsSelect.css';
var defaultProps = {
  locations: []
};
export default function LocationsSelect(_ref) {
  var locations = _ref.locations,
    onChange = _ref.onChange;
  var locationOptions = (locations || []).map(function (_ref2) {
    var _id = _ref2._id,
      name = _ref2.name,
      street = _ref2.street,
      city = _ref2.city;
    return {
      key: _id,
      value: _id,
      text: name || "".concat(street, ", ").concat(city)
    };
  });
  var defaultLocationId = getPrimaryLocationId(locations);
  return locationOptions.length >= 2 && /*#__PURE__*/React.createElement(Form.Select, {
    required: true,
    defaultValue: defaultLocationId,
    label: "Location",
    name: "location",
    placeholder: "Select Location",
    className: "locations-select",
    options: locationOptions,
    onChange: onChange
  });
}
LocationsSelect.defaultProps = defaultProps;